import { NgModule } from "@angular/core";
import {
  CommonModule,
  DatePipe,
  CurrencyPipe,
  DecimalPipe,
} from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import {
  UnauthorizedInterceptor,
  AuthTokenInterceptor,
  CorsInterceptor,
  CsrfInterceptor,
} from "@app/core/http-interceptors";

import { BarChartComponent } from "./components/bar-chart/bar-chart.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { MonthPickerComponent } from "./components/month-picker/month-picker.component";
import { MonthPeriodNavComponent } from "./components/month-period-nav";
import { InitialsAvatarComponent } from "./components/initials-avatar/initials-avatar.component";
import { BrandPinIconComponent } from "./components/brand-pin-icon/brand-pin-icon.component";
import { ProductIconComponent } from "./components/product-icon/product-icon.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { InfoTooltipComponent } from "./components/info-tooltip/info-tooltip.component";
import { IngoDatePipe, SafeUrlPipe } from "@app/shared/pipes";
import { IngoFormatCurrencyPipe } from "@app/shared/pipes";
import { IngoFormatNumberPipe } from "@app/shared/pipes";
import { DpDatePickerModule } from "ng2-date-picker";
import { CheckboxLabeledComponent } from "./components/checkbox-labeled/checkbox-labeled.component";
import { AddMastercardComponent } from "@app/features/cards/ui-components/add-mastercard/add-mastercard.component";
import { DayPickerComponent } from "./components/day-picker/day-picker.component";
import { DayPeriodNavComponent } from "./components/day-period-nav/day-period-nav.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    NgxMaskModule.forRoot(),
    NgbModule,
    FontAwesomeModule,
    DpDatePickerModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    NgxMaskModule,
    NgbModule,
    FontAwesomeModule,
    DpDatePickerModule,
    BarChartComponent,
    LoaderComponent,
    MonthPickerComponent,
    MonthPeriodNavComponent,
    InitialsAvatarComponent,
    BrandPinIconComponent,
    ProductIconComponent,
    PaginationComponent,
    CheckboxComponent,
    InfoTooltipComponent,
    IngoDatePipe,
    IngoFormatCurrencyPipe,
    IngoFormatNumberPipe,
    SafeUrlPipe,
    AddMastercardComponent,
    CheckboxLabeledComponent,
    DayPickerComponent,
    DayPeriodNavComponent,
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    DecimalPipe,
    IngoDatePipe,
    IngoFormatCurrencyPipe,
    IngoFormatNumberPipe,
    SafeUrlPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CsrfInterceptor,
      multi: true,
    },
  ],
  declarations: [
    BarChartComponent,
    LoaderComponent,
    MonthPickerComponent,
    MonthPeriodNavComponent,
    InitialsAvatarComponent,
    BrandPinIconComponent,
    ProductIconComponent,
    PaginationComponent,
    CheckboxComponent,
    InfoTooltipComponent,
    IngoDatePipe,
    IngoFormatCurrencyPipe,
    IngoFormatNumberPipe,
    SafeUrlPipe,
    AddMastercardComponent,
    CheckboxLabeledComponent,
    DayPickerComponent,
    DayPeriodNavComponent,
  ],
})
export class SharedModule {}
